module.exports = __webpack_public_path__ + "static/chauffage4-ea2dad62cb828a7656522853814efc7c.jpg";